import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";

import {
  requestConnectorsStatus,
  requestDeleteConnectorStatus,
  requestCreateConnectorStatus,
} from "../effects/connectors-effects";

const initialState = {
  list: [],
  item: null,
  loading: false,
  pageCount: 0,
  error: null,
};

const connectorsSlice = createSlice({
  name: slices.connectors,
  initialState,
  extraReducers: {
    ...requestConnectorsStatus,
    ...requestDeleteConnectorStatus,
    ...requestCreateConnectorStatus,
  },
});

const { actions, reducer } = connectorsSlice;

export { actions };

export default reducer;
